export function emptyToUndefined<T extends unknown[]>(value: T): T | undefined {
    return value.length === 0 ? undefined : value;
}
